import { publishOfferNative } from '../../../actions/webview';
import { TThunkAction } from '../../../../common/types/thunk';
import { mapPublishTerms } from './utils';
import { selectCurrentBet, selectIsAuctionSelected } from '../../../selectors/auction';
import { selectIsAutoProlongChecked } from '../../../selectors/checkoutInfo';
import {
  selectActivePackage,
  selectActiveService,
  selectIsIncreaseToMinimalTopBet,
  selectIsWithoutServices,
  selectPublicationPeriod,
  selectPublicationTokens,
  selectServiceUnavailableReason,
} from '../../../selectors/publishTerms';
import { getPublishTerms } from '../../../sagas/checkoutInfo/checkService/utils';
import { PROMOTION_SECTION_ID } from '../../../constants/nodeIds';
import { selectIsPublishToHiddenBase } from '../../../selectors/publishAvailable';
import { selectTermsDurationInDays } from '../../../selectors/termsDurations';
import { scrollToElement } from '../../../utils/layout';
import { publishOfferStart } from '../../../actions/publishInfo';
import { selectActivePlacingType } from '../../../reducers/v2/paidPublication/selectors';
import { selectMinimalBet } from '../../../reducers/v2/promotion/selectors';
import { selectPlacingMoneySource } from '../../../reducers/v2/moneySources/selectors';
import { logPublicationTokens } from '../../../utils/logPublicationTokens';

export const publishOffer =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { webview, logger }) => {
    const state = getState();

    const unavailableReason = selectServiceUnavailableReason(state);
    const isPublishToHiddenBase = selectIsPublishToHiddenBase(state);

    if (unavailableReason && !isPublishToHiddenBase) {
      scrollToElement(PROMOTION_SECTION_ID);

      return;
    }

    dispatch(publishOfferStart());

    const { auction, calltracking } = state.servicePickerWidget;

    const service = selectActiveService(state);
    const servicePackage = selectActivePackage(state);
    const publicationPeriod = selectPublicationPeriod(state);
    const isAuctionSelected = selectIsAuctionSelected(state);
    const placingType = selectActivePlacingType(state);
    const isAutoprolongChecked = selectIsAutoProlongChecked(state);
    const moneySource = selectPlacingMoneySource(state);
    const increaseToMinimalTopBet = selectIsIncreaseToMinimalTopBet(state);
    const isWithoutServices = selectIsWithoutServices(state);
    const minimalBet = selectMinimalBet(state);
    const termsDurationInDays = selectTermsDurationInDays(state);
    const publicationTokens = selectPublicationTokens(state);
    const currentBet = selectCurrentBet(state);

    logPublicationTokens(logger, state, publicationTokens, 'publishOffer');

    const terms = getPublishTerms({
      service,
      servicePackage,
      publicationPeriod,
      placingType,
      auction,
      isAuctionSelected,
      calltracking,
      moneySource,
      increaseToMinimalTopBet,
      isWithoutServices,
      minimalBet,
      termsDurationInDays,
      currentBet,
    });

    const publishTerms = mapPublishTerms({ isAutoprolongChecked, terms, publicationTokens });

    webview.sendAction(publishOfferNative({ publishTerms }));
  };
